module.exports = __webpack_public_path__ + "static/img/img-bk.17f1539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/img-bk.png
// module id = 0Zxs
// module chunks = 63